export const LAYOUT_TYPES = {
  DROPDOWN: 'Dropdown',
  DIVIDER: 'Divider',
  SPACER: 'Spacer',
  INSERT_MENU: 'InsertMenu'
};